// extracted by mini-css-extract-plugin
export default {"hidden":"_1b80a521","bold":"_b7857fce"};